import { Button } from "@mantine/core";
import { useState } from "react";
import ReactDOM from "react-dom";

interface CreateFormStepControlsProps {
  buttonContainer?: HTMLElement;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
}

function CreateFormStepControls({
  buttonContainer,
  onCancel,
  onSubmit
}: CreateFormStepControlsProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleClickSubmit() {
    setIsSubmitting(true);

    try {
      await onSubmit();
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="CreateFormStepControls">
      {buttonContainer &&
        ReactDOM.createPortal(
          <>
            <Button
              color="secondary"
              loading={isSubmitting}
              onClick={handleClickSubmit}
            >
              Erstellen
            </Button>
            <Button variant="default" onClick={onCancel}>
              Abbrechen
            </Button>
          </>,
          buttonContainer
        )}
    </div>
  );
}

export { CreateFormStepControls, CreateFormStepControlsProps };
